import {
  ISalePageDetailResponseProduct,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import { Radio } from '@/components';
import { Element } from '@vuddy/components';
import clsx from 'clsx';
import { ChangeEvent } from 'react';
import { PurchaseItemContent } from '../common/PurchaseItemContent';
import { disabledItem } from '../common/bottom.css';

interface PurchaseRadioItemProps {
  item: ISalePageDetailResponseProduct &
    ISalePageProductAdditionalInformResponse;
  selectedId?: number;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  hasVerificationCode?: boolean;
  verificationCodeName?: string;
  onCodeInputClick?: () => void;
}
export const PurchaseRadioItem = ({
  item,
  selectedId,
  onChange,
  hasVerificationCode,
  verificationCodeName,
  onCodeInputClick,
}: PurchaseRadioItemProps) => {
  const isPurchaseLimited =
    !item.isPurchasable && item.remainingPurchaseCount === 0;
  const disabled = item.saleStatus !== 'ON_SALE' || isPurchaseLimited;
  return (
    <Element
      paddingY="padding_small"
      className={clsx(disabled && disabledItem)}>
      <Radio
        value={item.id}
        checked={selectedId === item.id}
        disabled={disabled}
        onChange={onChange}
        gap="gap_xl"
        label={
          <PurchaseItemContent
            item={item}
            hasVerificationCode={hasVerificationCode}
            verificationCodeName={verificationCodeName}
            onCodeInputClick={onCodeInputClick}
          />
        }
      />
    </Element>
  );
};
